import { createHandlerChainRunnerForOldOnComplete, Handler } from "@insite/client-framework/HandlerCreator";
import { deleteCustomerPartNumber as deleteCustomerPartNumberApi } from "@tSchaedlerYesco/Services/CustomerPartNumberService";

export interface DeleteCpnParameter {
    id: string;
}

type HandlerType = Handler<
    {
        deleteCpn: DeleteCpnParameter;
        onComplete: (errorMessage: React.ReactNode) => void;
    },
    {
        apiParameter: any;
        apiResult?: any;
        result: any;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.deleteCpn;
};


export const RequestDataFromApi: HandlerType = props => {
    // eslint-disable-next-line no-console
    console.log("inside RequestDataFromApi", props);
    return deleteCustomerPartNumberApi(props.parameter.deleteCpn.id);
};

export const CallOnComplete: HandlerType = props => {
    props.parameter.onComplete(props.apiResult);
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    CallOnComplete
];

const deleteCustomerPartNumber = createHandlerChainRunnerForOldOnComplete(chain, "DeleteCustomerPartNumber");
export default deleteCustomerPartNumber;
